import React from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue } from 'recoil'

import styled from '@emotion/styled'

import { contentIndicatorState } from '../recoil/state'

import svgload from 'Helpers/svgload'

import IconCheck from 'mailup-web-components/src/img/icons/check.svg?raw'

const PreviewIndicatorContainer = styled.div`
  padding-top: 20px;
`

const PreviewIndicatorTitle = styled.h3`
  text-align: center;
  margin-top: 10px;
  margin-bottom: 10px;
`

const PreviewIndicatorDescription = styled.p`
  text-align: center;
  line-height: 20px;
  margin-bottom: 30px;

  ${({ count, total }) =>
    count === total &&
    `
      color: var(--emerald);
      font-size: 15px;
      font-weight: 500;

      &::before {
        content: '';
        display: inline-block;
        background-image: ${svgload(IconCheck, { path: { fill: '#59af26' } })};
        background-color: #c5e7b0;
        background-size: 13px;
        background-repeat: no-repeat;
        background-position: center 3px;
        width: 20px;
        height: 20px;
        border-radius: 10px;
        margin-right: 4px;
        padding-top: 1px;
        line-height: 20px;
        vertical-align: bottom;
      }

      
  `}
`

const PreviewIndicator = () => {
  const intl = useIntl()
  const [count, total] = useRecoilValue(contentIndicatorState)

  return (
    <PreviewIndicatorContainer>
      <PreviewIndicatorTitle>
        {intl.formatMessage({ id: 'Load.BeeContentDialog.PreviewTitle' })}
      </PreviewIndicatorTitle>
      <PreviewIndicatorDescription count={count} total={total}>
        {count === total ? (
          <>
            {intl.formatMessage({
              id: 'Load.BeeContentDialog.SelectionCompleted'
            })}
          </>
        ) : (
          <>
            {intl.formatMessage(
              {
                id: 'Load.BeeContentDialog.CurrentSelectionIntl'
              },
              {
                missing: chunks => (
                  <span className='notify-number is-danger'>{chunks}</span>
                ),
                total: total,
                left: total - count
              }
            )}
          </>
        )}
      </PreviewIndicatorDescription>
    </PreviewIndicatorContainer>
  )
}

export default PreviewIndicator
